// eslint-disable
// this is an auto generated file. This will be overwritten

export const getInspection = `query GetInspection($id: ID!) {
  getInspection(id: $id) {
    id
    uId
    vId
    date
    odometer
    status
    metadata
    items
  }
}
`;

export const inspectionsByUser = `query InspectionsByUser($uId: ID!, $limit: Int, $nextToken: String) {
  inspectionsByUser(uId: $uId, limit: $limit, nextToken: $nextToken) {
    items {
      id
      uId
      vId
      date
      odometer
      status
      metadata
      items
    }
    nextToken
  }
}
`;

export const listInspections = `query ListInspections(
  $filter: ModelInspectionFilterInput
  $limit: Int
  $nextToken: String
) {
  listInspections(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      uId
      vId
      date
      odometer
      status
      metadata
      items
    }
    nextToken
  }
}
`;
export const getVehicle = `query GetVehicle($id: ID!) {
  getVehicle(id: $id) {
    id
    uId
    recentInspectionId
    data
  }
}
`;
export const listVehicles = `query ListVehicles(
  $filter: ModelVehicleFilterInput
  $limit: Int
  $nextToken: String
) {
  listVehicles(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      uId
      recentInspectionId
      data
    }
    nextToken
  }
}
`;
export const getPhoto = `query GetPhoto($id: ID!) {
  getPhoto(id: $id) {
    id
    key
    file {
      bucket
      region
      key
      mimeType
      localUri
    }
  }
}
`;
export const listPhotos = `query ListPhotos(
  $filter: ModelPhotoFilterInput
  $limit: Int
  $nextToken: String
) {
  listPhotos(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      key
    }
    nextToken
  }
}
`;
export const getUser = `query GetUser($id: ID!) {
  getUser(id: $id) {
    id
    uId
    tier
    dateCreated
    inspectionsLimit
    vehiclesLimit
    metadata
  }
}
`;
export const listUsers = `query ListUsers(
  $filter: TableUserFilterInput
  $limit: Int
  $nextToken: String
) {
  listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      uId
      tier
      dateCreated
      inspectionsLimit
      vehiclesLimit
      metadata
    }
    nextToken
  }
}
`;
export const getCustomInspection = `query GetCustomInspection($id: ID!) {
  getCustomInspection(id: $id) {
    id
    uId
    type
    fallback
    items
  }
}
`;
export const listCustomInspections = `query ListCustomInspections(
  $filter: TableCustomInspectionFilterInput
  $limit: Int
  $nextToken: String
) {
  listCustomInspections(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      uId
      type
      fallback
      items
    }
    nextToken
  }
}
`;
